export default __webpack_public_path__ + "static/media/3.c2fe4e88.png";